function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m31 13h18v2h-18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m31 17h18v2h-18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m31 21h18v2h-18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m31 25h18v2h-18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7 5h26v2h-26z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7 9h18v2h-18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7 13h18v2h-18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7 17h18v2h-18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m62.707 33.293-4-4c-.391-.391-1.023-.391-1.414 0l-2.293 2.293v-1.586c0-.553-.448-1-1-1h-1v-19c0-.553-.448-1-1-1h-15v-7c0-.553-.448-1-1-1h-32c-.552 0-1 .447-1 1v19h-1c-.552 0-1 .447-1 1v36c0 .553.448 1 1 1h28.198l-1.117 2.606c-.161.375-.077.812.212 1.101.191.191.447.293.707.293.133 0 .267-.026.394-.081l7-3c.117-.05.223-.122.313-.212l.707-.707h15.586c.552 0 1-.447 1-1v-15.586l7.707-7.707c.391-.391.391-1.023 0-1.414zm-28.293 21.707 18.586-18.586 2.586 2.586-18.586 18.586zm16.586-26h-20.586l-1.414-1.414v-16.586h22zm-46-26h30v6h-7c-.552 0-1 .447-1 1v15.586l-4.293-4.293c-.187-.188-.442-.293-.707-.293h-17zm-2 54v-34h18.586l7.707 7.707c.187.188.442.293.707.293h23v2.586l-20.707 20.707c-.09.09-.162.196-.212.313l-1.026 2.394zm30.337-.249 1.911 1.911-3.344 1.433zm19.663.249h-12.586l12.586-12.586zm4-19.414-2.586-2.586 3.586-3.586 2.586 2.586z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10 27h-4c-.552 0-1 .447-1 1v16c0 .553.448 1 1 1h4c.552 0 1-.447 1-1v-16c0-.553-.448-1-1-1zm-1 16h-2v-14h2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10 47h-4c-.552 0-1 .447-1 1v4c0 .553.448 1 1 1h4c.552 0 1-.447 1-1v-4c0-.553-.448-1-1-1zm-1 4h-2v-2h2z"
}));

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.8e416de5.svg";
export { ForwardRef as ReactComponent };